import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { trackClickInteriorDecoration, trackInteriorDecorationShowing } from './tracking';
import { Content, FullscreenPopup } from '../../components/FullscreenPopup';
import { InteriorDecoration } from '../../components/InteriorDecoration';
import { Layout } from '../../components/Layout';
import { getNewbuildingId, getInteriorDecoration } from '../../selectors/newbuilding';
import { AsideContentPopupHeader } from '../AsideContentPopupHeader';

const INTERIOR_POPUP_FAVORITE_EVENT_ACTIONS = {
  add: 'add_from_jk_finish',
  remove: 'remove_from_jk_finish',
};

export function InteriorDecorationContainer() {
  const list = useSelector(getInteriorDecoration);
  const id = useSelector(getNewbuildingId);
  const [isOpened, setOpenedState] = React.useState(false);
  const [index, setIndex] = React.useState(0);

  const onItemClick = React.useCallback(
    (i: number) => {
      setIndex(i);
      setOpenedState(true);
      trackClickInteriorDecoration(id, list[i].type);
    },
    [setOpenedState, setIndex],
  );

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!list.length) {
    return null;
  }

  const item = list[index];

  return (
    <Layout>
      <ActionAfterViewObserver callback={trackInteriorDecorationShowing} triggerOnce>
        <InteriorDecoration items={list} onItemClick={onItemClick} />
      </ActionAfterViewObserver>
      <FullscreenPopup
        isOpened={isOpened}
        header={
          <AsideContentPopupHeader
            onClose={onClose}
            favoriteActions={INTERIOR_POPUP_FAVORITE_EVENT_ACTIONS}
            callAction="Open_jk_finish"
            dynamicCallTrackingTitle="InteriorDecoration"
          />
        }
        onClose={onClose}
        content={<Content title={item.title} description={item.description} images={item.images} />}
      />
    </Layout>
  );
}
